import React from 'react';
import { WithAuth } from '@planity/components';
import { OnlineBusinessStatus } from '../business_booking/online_payment/onlineStatus';
import { OnlinePaymentProvider } from '../business_booking/online_payment/providerComponent';
import BookAppointmentComponent from './book_appointment';
import { useLocalization } from '@planity/localization';

export function BookAppointment(props) {
	const { locale } = useLocalization();
	return (
		<WithAuth skipIsAdmin={true}>
			{({ userId, isVerified, user, isPro, isLoading }) => (
				<OnlineBusinessStatus business={props.business}>
					{({ status }) => (
						<OnlinePaymentProvider business={props.business}>
							<BookAppointmentComponent
								{...props}
								isAuthLoading={isLoading}
								isPro={isPro}
								isVerified={isVerified}
								locale={locale}
								status={status}
								user={user}
								userId={userId}
							/>
						</OnlinePaymentProvider>
					)}
				</OnlineBusinessStatus>
			)}
		</WithAuth>
	);
}
